/**
 * Messages Page
 * Internal messaging and notifications
 */

import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export const Messages: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="flex items-center space-x-4 mb-6">
          <div className="p-3 bg-teal-100 rounded-lg">
            <EnvelopeIcon className="h-8 w-8 text-teal-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Messages</h1>
            <p className="text-gray-500">Internal messaging and notifications</p>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6">
          <div className="bg-teal-50 rounded-lg p-6 text-center">
            <p className="text-teal-800 text-lg">
              This page will display internal messages, alerts, and notifications
              related to forecasting activities and system updates.
            </p>
            <p className="text-teal-600 mt-2 text-sm">Coming Soon</p>
          </div>
        </div>
      </div>
    </div>
  );
};
